/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from './SuggestedTopicState.types.tsx';

export const setPagination =
	(currentPage: number) =>
	async ({ getState, setState }: StoreActionApi<State>): Promise<void> => {
		const state = getState();
		setState({
			...state,
			page: currentPage,
		});
	};
